import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { BaseLayout } from "../components";
import {
  CertificatesPage,
  CoursePage,
  CoursesPage,
  FavouritesPage,
  HomePage,
  ModulePage,
  TeachersPage
} from "../features/learn";
import TeacherPage from "../features/learn/TeacherPage";

export default function LearnPage() {
  const { path } = useRouteMatch();

  return (
    <BaseLayout>
      <Switch>
        <Route exact path={path} component={HomePage} />
        <Route exact path={`${path}/courses`} component={CoursesPage} />
        <Route exact path={`${path}/courses/:courseId`} component={CoursePage} />
        <Route exact path={`${path}/course_modules/:idModule`} component={ModulePage} />
        <Route exact path={`${path}/favourites`} component={FavouritesPage} />
        <Route exact path={`${path}/certificates`} component={CertificatesPage} />
        <Route exact path={`${path}/teachers`} component={TeachersPage} />
        <Route exact path={`${path}/teachers/:profileId`} component={TeacherPage} />
      </Switch>
    </BaseLayout>
  );
}
